import type { Dispatch } from "redux";
import actions from "~/shared/actions";
import type { State } from "~/shared/reducers";

export function initStore(state: State) {
	return (dispatch: Dispatch) => dispatch(actions.initStore(state));
}
